import { useLayoutEffect, useState } from "react";

/**
 * Clears stale session state before ChatPanel mounts.
 *
 * @param shouldClear - Whether to perform any clearing at all
 * @param clearSession - If true, clears chatAnonymousId AND EXPERIENCE_VARIANT cookie.
 *                       If false, preserves both (only gates rendering).
 *
 * Returns `ready` — gate ChatPanel rendering on this to ensure
 * state is cleared before ChatPanel's init useEffect reads it.
 */
export function useSessionReset(shouldClear: boolean, clearSession = true) {
  const [ready, setReady] = useState(false);
  useLayoutEffect(() => {
    if (shouldClear && clearSession) {
      localStorage.removeItem("chatAnonymousId");
      document.cookie = "EXPERIENCE_VARIANT=; path=/; max-age=0";
    }
    setReady(true);
  }, [shouldClear, clearSession]);
  return ready;
}
